import React from "react";

export default function Footer() {
  return (
    <footer className="shrink-0 flex items-center justify-between px-5 lg:px-7 py-3 text-[11px] font-semibold text-slate-400 border-t border-slate-300/30">
      <span>© {new Date().getFullYear()} MediLearn. All rights reserved.</span>
      <span className="hidden sm:block tracking-wide uppercase text-[10px]">HRMS</span>
    </footer>
  );
}
